import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ProductFlowService, ProductFlowConfig, FlowImportRequest } from 'app/infrastructure/services/productFlow.service';
import { AlertService, GrowlType } from 'app/infrastructure/services/alert.service';
import { File64 } from 'app/helpers/components/sxFileImport/file64.interf';
import { OpcionCheckeable } from 'app/infrastructure/services/selects.service';
import { StandardDictionary } from 'app/infrastructure/model/interfaces/standarddictionary.interface';
import { SxDocumentTypes } from 'app/private/sxfdesigner/components/main/completeContext';
import { SxTranslationService } from 'app/infrastructure/services/translation-service.service';

@Component({
    selector: 'sx-import-dynamic-flow',
    templateUrl: './importDynamicFlow.component.html',
})
export class ImportDynamicFlowComponent implements OnInit {
    systemCode: string;
    businessCode: string;
    productCode: string;
    documentKind = 'Policy';
    flowCode: string;
    supported: string[] = ['.xlsx'];
    file: File64 = null;
    standardFlow: boolean;
    importFlow: boolean;
    categories: OpcionCheckeable[];
    standardDictionary: StandardDictionary[];

    standardDictionaryId: string;
    selectedCategories: string[];

    constructor(private productFlowService: ProductFlowService,
        private router: Router,
        private aRoute: ActivatedRoute,
        private alertService: AlertService,
        private sxTranslationService: SxTranslationService) {
          this.aRoute.data.subscribe((data) => {
            this.standardFlow =
              data.standardFlow != undefined ? data.standardFlow : false;
      
            this.importFlow = data.importFlow != undefined ? data.importFlow : false;
          });
         }

    ngOnInit() {
        this.aRoute.params.subscribe((params: Params) => {
            this.systemCode = params['codsistema'];
            this.businessCode = params['codnegocio'];
            this.productCode = params['codproducto'];
            this.documentKind = params['documentKind'];
            if (this.systemCode === undefined) {
                this.systemCode = "null";
              }
              if (this.businessCode === undefined) {
                this.businessCode = "null";
              }
              if (this.productCode === undefined) {
                this.productCode = "null";
              }
              if (this.documentKind === undefined) {
                this.documentKind = SxDocumentTypes.None;
              }

            if (this.standardFlow) {
                this.productFlowService.getCategories().then(x => {
                  this.categories = x as OpcionCheckeable[];
                });
                this.productFlowService.getStandardDictionary().then(x => {
                  this.standardDictionary = x as StandardDictionary[];
                });
                this.supported = ['.json'];
              }else{
                this.supported = ['.xlsx'];
              }
        });
    }

    selectedFile(imp: File64) {
        this.file = imp;
    }

    createFlow() {
      if (!this.file) {
            this.alertService.showGrowl({
                type: GrowlType.DANGER,
                body: 'SOC_FE_0002_MUST_SELECT_A_FILE'
            });
            return;
        }

        let flowToImport: FlowImportRequest;
        flowToImport = {
            systemCode: this.systemCode,
            businessCode: this.businessCode,
            productCode: this.productCode,
            fileName: this.file.fileName,
            flowCode: this.flowCode,
            file: this.file.fileData,
            documentKind: this.documentKind,
            categories: this.selectedCategories,
            standardDictionary: this.standardDictionaryId
        };

        if(this.standardFlow){
          this.productFlowService.importStandardFlowFromFile(flowToImport).then(isOk => {
            if (isOk) {
                this.alertService.showGrowl({
                    type: GrowlType.SUCCESS,
                    body: this.sxTranslationService.getResource('IMPORT_FLOW_SUCCESS')
                });
                this.router.navigate(['../','standardFlows']);
            } else {
                this.alertService.showGrowl({
                    type: GrowlType.DANGER,
                    body: this.sxTranslationService.getResource('IMPORT_FLOW_ERROR')
                });
            }
          });
        }else{
          this.productFlowService.importFlowFromFile(flowToImport).then(isOk => {
            if (isOk) {
                this.alertService.showGrowl({
                    type: GrowlType.SUCCESS,
                    body: this.sxTranslationService.getResource('IMPORT_FLOW_SUCCESS')
                });
                this.back();
            } else {
                this.alertService.showGrowl({
                    type: GrowlType.DANGER,
                    body: this.sxTranslationService.getResource('IMPORT_FLOW_ERROR')
                });
            }
          });
        }

    }

  
    isValidForm(){
      if(this.standardFlow){
        return this.flowCode && this.file && this.categories.length > 0 && this.standardDictionaryId
      }else{
        return this.flowCode && this.file;
      }
    }

    back() {
      if (this.standardFlow || this.importFlow) {
        this.router.navigate(['../standardFlows'], { relativeTo: this.aRoute });
      } else {
        this.router.navigate(['../'], { relativeTo: this.aRoute });
      }
    }

    changeCategories(categories: OpcionCheckeable[]) {
        this.selectedCategories = [];
        if (categories) {
          categories.forEach(category =>
            this.selectedCategories.push(category.id)
          );
        }
      }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/dynamicFlow/importDynamicFlow/importDynamicFlow.component.ts